import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import HighlightPlayer from "../../Components/VideoPlayer";
import useConfig from "../../Hooks/useConfig";

interface VideoPlayerDialogProps {
  open: boolean;
  onClose: () => void;

  event_id: string;
}

const VideoPlayerDialog: React.FC<VideoPlayerDialogProps> = ({
  open,
  onClose,
  event_id,
}) => {
  const { api } = useConfig();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <HighlightPlayer
          url={`${api}/v1/assembly?event_ids=${event_id}&bypass=true`}
        />
      </DialogContent>
    </Dialog>
  );
};

export default VideoPlayerDialog;
